export default "__VITE_ASSET__U7UyfVYX__"